import { render, staticRenderFns } from "./TwodThreed.vue?vue&type=template&id=2a062d6f&scoped=true"
import script from "./TwodThreed.vue?vue&type=script&lang=js"
export * from "./TwodThreed.vue?vue&type=script&lang=js"
import style0 from "./TwodThreed.vue?vue&type=style&index=0&id=2a062d6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a062d6f",
  null
  
)

export default component.exports